import React from "react";
import {ValidatedForm, FormContext} from "../../../../elements/validator/validatedForm/ValidatedForm";
import {UpdateBotLeadSettingsRequest} from "../../../../../api/generated";
import {Button, ButtonState} from "../../../../elements/button/Button";
import {RequestStatus} from "../../../../../api/apiConfiguration";
import styles from "./LeadsForm.module.css";
import {LeadIntegrationConfiguration} from "./components/LeadIntegrationConfiguration";

interface LeadsFormProps {
    hasUnsavedChanges: boolean;
    onSave: () => Promise<void>;
    onDiscard: () => void;
    updateStatus: RequestStatus;
}

export const LeadsForm: React.FC<LeadsFormProps> = ({
                                                         hasUnsavedChanges,
                                                         onSave,
                                                         onDiscard,
                                                         updateStatus
                                                     }) => {
    return (
        <ValidatedForm<UpdateBotLeadSettingsRequest> submitForm={onSave}>
            {(formCtx: FormContext<UpdateBotLeadSettingsRequest>) => {
                const {updateValidationStatus, getMessage, formDisabled, onSubmitClick} = formCtx;

                const getMessageWrapper = (f: string): string => {
                    return getMessage(f as keyof UpdateBotLeadSettingsRequest) || '';
                };

                return <div className={styles.wrapper}>
                    <LeadIntegrationConfiguration
                        updateValidationStatus={updateValidationStatus}
                        getMessage={getMessageWrapper}
                    />

                    <div className={styles.buttonContainer}>
                        <Button
                            title="Discard Changes"
                            state={hasUnsavedChanges ? ButtonState.SECONDARY : ButtonState.DISABLED}
                            handleClick={onDiscard}
                        />
                        <Button
                            title="Save Changes"
                            state={formDisabled || updateStatus === RequestStatus.PENDING
                                ? ButtonState.DISABLED
                                : ButtonState.PRIMARY}
                            handleClick={onSubmitClick}
                        />
                    </div>
                </div>
            }}
        </ValidatedForm>
    );
}
